import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

type ListControlProps = {
  insertAction: () => void;
  deleteAction: () => void;
  upAction: () => void;
  downAction: () => void;
};

const useStyles = makeStyles(
  createStyles({
    container: {
      display: 'flex',
      flexFlow: 'column',
      margin: '4px',
    },
    button: {
      width: '150px',
      margin: '2px',
    },
  })
);

const ListControl: React.FC<ListControlProps> = (props: ListControlProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.insertAction();
      }}>{t('ListControl.挿入','挿入')}</Button>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.deleteAction();
      }}>{t('ListControl.削除','削除')}</Button>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.upAction();
      }}>↑</Button>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.downAction();
      }}>↓</Button>
    </div>
  );
};

export default ListControl;
